export default __webpack_public_path__ + "static/alley-d23d5a742eb14c45d01a3ee960bcdadf.svg";